import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { DocumentDownloadIcon, QuestionMarkCircleIcon, SearchIcon } from '@heroicons/react/solid';
import { convert, formatDate } from '../../utils/convertDate';
import { FormatMoney } from '../../utils/formatMoney';
import GeneralTable from '../../components/GeneralTable';
import { useNavigate } from 'react-router-dom';
import TreasuryBillClass from '../../services/treasuryBill';
import { toast } from 'react-toastify';
import Modal from '../../components/Modals/Modal';


const oldFrom = new Date().setDate(new Date().getDate() - 7);
const defaultTo = formatDate(new Date());
const longNew = formatDate(defaultTo);
const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
const longDate = formatDate(defaultFrom);

const TreasuryListings = () => {
    const navigate = useNavigate()
    
    const [searchTreasuryBills, setSearchTreasuryBills] = useState("")
    const [selectedTenorClass, setSelectedTenorClass] = useState(""); // New state for tenor class
    const [too, setToo] = useState(convert(longNew));
    const [fromm, setFromm] = useState(convert(longDate));
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    });
    const [selectedStatus, setSelectedStatus] = useState(''); // New state for status filter
    const [adminType, setAdminType] = useState("");

    // State for pagination
  const [pageIndex, setPageIndex] = useState(1);
  const itemsPerPage = 10; // Adjust as needed

  // New state for treasury bill listings
  const [listings, setListings] = useState([]);
  const [totalListingsCount, setTotalListingsCount] = useState(0);
  const [totalPagesCount, setTotalPagesCount] = useState(0);

  // State for deactivation confirmation modal
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [itemToDeactivate, setItemToDeactivate] = useState(null);

  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  }, [])
  // Pagination handlers
  const prevPage = () => {
    if (pageIndex > 1) setPageIndex(pageIndex - 1);
  };

  const nextPage = () => {
    if (pageIndex < totalPagesCount) setPageIndex(pageIndex + 1);
  }

  // Define columns
  const columns = [
    { key: 'tBillID', header: 'T-Bill ID' },
    { key: 'volume', header: 'Volume', render: (item) => FormatMoney(item.volume, 'NGN') },
    { key: 'tenor', header: 'Tenor' },
    { key: 'discountRate', header: 'Discount Rate', render: (item) => `${item.discountRate}%` },
    { key: 'dateCreated', header: 'Date Issued', render: (item) => convert(item.dateCreated) },
    { key: 'maturityDate', header: 'Maturity Date', render: (item) => convert(item.maturityDate) },
    { key: 'redemptionValue', header: 'Redemption Value', render: (item) => FormatMoney(item.redemptionValue, 'NGN')  },
    { key: 'modifiedBy', header: 'Last Modified By', render: (item) => item.modifiedBy ?? "-" },
    { key: 'status', header: 'Status', render: (item) => {
      const status = item?.status?.toLowerCase() || '';
      const statusColors = {
        'initiated': 'text-blue-500 font-semibold',
        'approved': 'text-green-500 font-semibold',
        'pending': 'text-yellow-500 font-semibold',
        'rejected': 'text-red-500 font-semibold'
      };
      const colorClass = statusColors[status] || 'text-gray-500 font-semibold';
      return <span className={colorClass}>{item.status || '-'}</span>;
    }},
     { key: 'createdBy', header: 'createdBy'}
  ];

  const GetListings = async (
    page, 
    pageSize, 
    search, 
    startDate, 
    endDate, 
    status,
    tenorclass
  ) => {
    try {
        const response = await TreasuryBillClass.ListOfTreasuryBills(
            page, 
            pageSize, 
            search, 
            startDate, 
            endDate, 
            status,
            tenorclass
        );
        console.log("listing", response)
        setListings(response.data.result);
        setTotalListingsCount(response.data.totalCount);
        setTotalPagesCount(Math.ceil(response.data.totalCount / itemsPerPage));
    } catch (error) {
        console.error("Error fetching treasury bills:", error);
        setListings([]);
        setTotalListingsCount(0);
        setTotalPagesCount(0);
    }
}
  useEffect(() => {
    
    GetListings(
        pageIndex, 
        itemsPerPage, 
        "", 
        fromm, 
        too, 
        selectedStatus,
        selectedTenorClass
    );
  }, [pageIndex, itemsPerPage, fromm, too, selectedStatus, selectedTenorClass])

    const range = async (e) => {
        e.preventDefault();
        GetListings(
            pageIndex, 
            itemsPerPage, 
            searchTreasuryBills, 
            fromm, 
            too, 
            selectedStatus,
            selectedTenorClass
        );
    }

    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event });
            setFromm(formatDate(event));
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event });
            setToo(formatDate(event));
        }
    };

    const exportCSV = async () => {
         const resp = await TreasuryBillClass.exportTreasuryBills(searchTreasuryBills, fromm, too, selectedStatus);
         if(resp){
            window.open(resp.data)
         }
    }

    // Define actions - function that returns actions based on item status
    const getActions = (item) => {
      const baseActions = adminType.toLowerCase() === "checker" 
        ? ['View T-Bill', 'Deactivate T-Bill'] 
        : ['View T-Bill', 'Edit T-Bill', 'Deactivate T-Bill'];
      
      // Don't show deactivate action if status is Initiated or Rejected, or if item is deleted
      const status = item?.status?.toLowerCase();
      if (status === 'initiated' || status === 'rejected' || item?.isDeleted) {
        return baseActions.filter(action => action !== 'Deactivate T-Bill');
      }
      
      return baseActions;
    };

  // Handle action selection
  const handleActionSelect = async (action, item) => {
    // Add logic here to process the action (e.g., API call, state update)
    if(action === "View T-Bill"){
        navigate(`/treasury/view?${item?.id}`)
    }
    if(action === "Edit T-Bill"){
        navigate(`/treasury/edit?${item?.id}`)
    }
    if(action === "Deactivate T-Bill"){
        setItemToDeactivate(item);
        setIsDeactivateModalOpen(true);
    }
  };

  // Handle deactivation confirmation
  const handleDeactivateConfirm = async () => {
    if (itemToDeactivate) {
        const response = await TreasuryBillClass.deactivateBooking(itemToDeactivate.id)
        if(response){
            console.log("done", response)
            toast.success(response.message)
            setIsDeactivateModalOpen(false);
            setItemToDeactivate(null);
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    }
  };

  // Handle deactivation cancellation
  const handleDeactivateCancel = () => {
    setIsDeactivateModalOpen(false);
    setItemToDeactivate(null);
  };
  
    return (
        <Layout title="Treasury Bill" pageTag={"treasury_bill"} current={'/treasury'}>
            <React.Fragment>
                <main className='mt-5'>
                    <div className="sm:flex sm:items-center justify-between flex-wrap">
                        
                            <div className=" relative rounded-md shadow-sm ">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ">
                            <p className='text-sm leading-3 text-gray-500 mb-2'>Tenor class</p>
                                <select
                                    id="tenorClass"
                                    name="tenorClass"
                                    className="block  pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md w-48"
                                    value={selectedTenorClass}
                                    onChange={(e) => setSelectedTenorClass(e.target.value)}
                                >
                                    <option value="">Select Tenor Class</option>
                                    <option value="LessThanNinetyDays">less than 90 days</option>
                                    <option value="LessThanHundredAndEightyDays">less than 180 days</option>
                                    <option value="LessThanThreeHundredAndSixtyFiveDays">less than 365 days</option>
                                </select>
                            </div>
                            <div className=" relative rounded-md shadow-sm ">
                            <p className='text-sm leading-3 text-gray-500 mb-2'>Status</p>
                                <select
                                    id="statusFilter"
                                    name="statusFilter"
                                    className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md w-48"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="">None</option>
                                    <option value="Initiated">Initiated</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Rejected">Rejected</option>
                                </select>
                            </div>
                            <div className=" relative rounded-md shadow-sm ">
                            <p className='text-sm leading-3 text-gray-500 mb-2 h-3'></p>
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none mt-5">
                                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>
                                <input
                                    type="text"
                                    name="treasuryBills"
                                    id="treasuryBills"
                                    onChange={(e) => setSearchTreasuryBills(e.target.value)}
                                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                    placeholder="Search Treasury Bills"
                                />
                                <div className=" absolute inset-y-0 right-0 flex items-center pr-3 mt-5">
                                    <div className='tooltip'>
                                        <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                        <span className="tooltiptext"> <p>Search treasury bills</p></span>
                                    </div>
                                </div>
                            </div>
                           <div>
                           <p className='text-sm leading-3 text-gray-500 mb-2 h-3'></p>
                           <button
                                onClick={range}
                                className='hover:text-white active:text-white inline-flex items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                           </div>
                           <div>
                           <p className='text-sm leading-3 text-gray-500 mb-2 h-3'></p>
                           <button onClick={() => navigate("/treasury/create")} className="inline-flex items-center text-white active:text-white justify-center rounded-md border border-transparent bg-red-600 px-2 py-2 text-sm font-medium shadow-sm  sm:w-auto">
                                Create T-Bills
                            </button>
                           </div>
                            <div>
                            <p className='text-sm leading-3 text-gray-500 mb-2 h-3'></p>
                            <button
                                type="button"
                                onClick={exportCSV}
                                className="inline-flex items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm  sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                            </div>
                    </div>

                    {/* table */}
                    <GeneralTable
                        columns={columns}
                        data={listings}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={totalListingsCount}
                        totalPages={totalPagesCount}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                        actions={getActions}
        onActionSelect={handleActionSelect}
                    />

                    {/* Deactivation Confirmation Modal */}
                    <Modal
                        isOpen={isDeactivateModalOpen}
                        onClose={handleDeactivateCancel}
                        onConfirm={handleDeactivateConfirm}
                        onCancel={handleDeactivateCancel}
                        modalTitle="Deactivate Treasury Bill"
                        modalText={`Are you sure you want to deactivate this Treasury Bill (${itemToDeactivate?.tBillID})? This action may affect related transactions.`}
                    />
                </main>

            </React.Fragment>
        </Layout>
    )
}

export default TreasuryListings